import { View, Text } from 'src/components/common';
import { connect } from 'react-redux';
import 'src/components/DepositionDetailItem/styles.scss';
import { IAppState } from 'src/store';
const InformationText: React.FC<Props> = ({ title, value }) => {
  return (
    <View className={'mt-4'}>
      <Text className={'detail-item-text'}>{title}</Text>
      <Text>{value}</Text>
    </View>
  );
};

type Props = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps & {
    title: string;
    value: any;
  };
const mapStateToProps = (state: IAppState) => ({});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InformationText);
